export const NUMBER_OF_GUESSES = 6;

export const WORD_LENGTH = 5;

export const BACKSPACE_KEYS = ["Backspace", "←"];
export const ENTER_KEYS = ["Enter", "⏎"];

export const languages = [
    "English",
    "Croatian"
]

export const keyboard = [
    ["Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "←"], 
    ["A", "S", "D", "F", "G", "H", "J", "K", "L", "⏎"], 
    ["Y", "X", "C", "V", "B", "N", "M"]
]